import React from "react";

const DEFAULT_ITEMS = [
  "FREEDOM IN EVERY CUP",
  "BREWED IN THE USA",
  "EST. 2026",
  "YOU WERE BORN FREE!",
];

export const Marquee = ({ items = DEFAULT_ITEMS, speed = "normal" }) => {
  const animClass = speed === "fast" ? "animate-marquee-fast" : "animate-marquee";
  // Duplicate items so the loop reads continuously
  const loop = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="brand-marquee"
      className="w-full overflow-hidden bg-red text-bone border-y-2 border-navy"
    >
      <div className={`marquee-track ${animClass}`}>
        {loop.map((t, i) => (
          <span
            key={i}
            className="font-mono uppercase tracking-[0.25em] text-xs sm:text-sm py-2 px-6 inline-flex items-center"
          >
            <span>{t}</span>
            <span aria-hidden className="mx-6 text-bone/80">
              ✦
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
